import React from 'react'
import Navbar from './Navbar';
import Board from './Board';

export default function MakeTest() {


  return (

    <div className="make-test">
      <Navbar />

      <div className="container">
        <div className="row pt-3 text-center">
          <div className="col">
            {/* <img
              src={"lib-c2.png"}
              className="img-dragonfly"
              alt="..."
            ></img> */}
            {/* <h2 className="text-light mt-3">The 12 Colors Test</h2> */}

          </div>
        </div>

        <Board il={0} />
      </div>
    </div>
  )
}


